import moment from 'moment'
import timezone from 'moment-timezone'
import { Record, List, Map } from 'immutable'
import { normalizedTimezone, getSupportedTimezones } from 'utils/timezoneHelpers'

export const WEEKDAYS = 'WEEKDAYS'

export const HOUR_LABEL_FORMAT = 'h:mmA'
export const HOUR_FORMAT = 'HH:mm:ss'

export const MIDNIGHT_VALUE = '23:59:59'
export const MIDNIGHT_LABEL = '11:59PM'

const DEFAULT_OPEN = '09:00:00'
const DEFAULT_CLOSE = '17:00:00'

export const Hours = Record({
  opens: DEFAULT_OPEN,
  closes: DEFAULT_CLOSE,
  dayOfWeek: WEEKDAYS,
})

export const DAYS = List.of(
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
)

export const DAY_RANGES = List.of(
  'EVERYDAY',
  'WEEKDAYS',
  'WEEKENDS',
)

export const DAY_OPTIONS = DAY_RANGES.concat(DAYS).map((day) => ({
  label: day.toLowerCase(),
  value: day,
})).toJS()

export const DAY_OPTIONS_ORDER = DAYS.concat(DAY_RANGES).reduce((days, day, index) => {
  return days.set(day, index)
}, Map()).toJS()

export const TIMEZONE_OPTIONS = getSupportedTimezones()
  .map((zone) => {
    return { value: zone, label: normalizedTimezone(zone) }
  })

const HOUR_OPTIONS = _.range(24).reduce((result, time) => {
  const hour = moment(time, 'H')
  const midHour = moment(hour).add(30, 'minutes')

  result.push({ value: hour.format(HOUR_FORMAT), label: hour.format(HOUR_LABEL_FORMAT)})
  result.push({ value: midHour.format(HOUR_FORMAT), label: midHour.format(HOUR_LABEL_FORMAT)})
  return result
}, [])
HOUR_OPTIONS.push({ value: MIDNIGHT_VALUE, label: MIDNIGHT_LABEL})

export { HOUR_OPTIONS }

export const NotificationMessages = {
  AVAILABILITY: 'The availability settings of your Chat Widget have been updated!',
  TARGETING: 'The targeting settings of your Chat Widget have been updated!'
}



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Availability/Constants.js